<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<div class="main">
				<el-button class="fanhuiBtn" @click="fanhui()">返回</el-button>
				<div class="yonghuminglabe">字典新增</div>
				<div class="header-con">
					<div class="maina">
						<el-form :model="form" :rules="formRule" ref="form" label-width="140px" label-position="right"
							style="display: inline">
							<el-row>

								<el-form-item style="width:90%" label="名称：" prop="zidianmingcheng">
									<el-input style="width:90%" type="text" v-model="form.zidianmingcheng"
										ref="zidianmingcheng" @keyup.enter.native="xzlujingdizhi"
										placeholder="请输入名称,助记码默认当前名称首字母">
									</el-input>

								</el-form-item>

								<el-form-item style="width:90%" label="分类：" prop="fenlei">
									<el-select style="width:90%" v-model="form.fenlei" disabled filterable
										placeholder="输入关键词搜索" :filter-method="bindSelectChange" @change="dianjifenlei"
										popper-class="eloption">
										<el-option v-for="item in fenleiarr" :key="item.Code" :label="item.Name"
											:value="item.Code" :value-key="item.Code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item style="width:90%" label="状态：" prop="zhuangtai">
									<el-select style="width:90%" v-model="form.zhuangtai" filterable clearable
										placeholder="输入关键词搜索" :filter-method="bindSelectChangezt"
										@change="dianjizhuangtai" popper-class="eloption">
										<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
											:value="item.Code" :value-key="item.Code">
										</el-option>
									</el-select>
								</el-form-item>









								<el-col :span="24">

									<el-button class="tijiaobtn" type="primary" @click="submitForm()" :disabled="isTiJiao">提交
									</el-button>
								</el-col>
							</el-row>

						</el-form>

					</div>


				</div>
			</div>

		</el-scrollbar>

	</div>
</template>

<script>
	import pinyin from 'js-pinyin'
	import PinyinMatch from "pinyin-match";
	export default {
		name: "zidianxinzeng",
		data() {
			return {
				/**表单 */
				form: {
					zidianmingcheng: JSON.parse(this.$route.query.arr).TITLE, //字典名称
					zhuangtai: JSON.parse(this.$route.query.arr).DICTIONARIES_STATUS, //状态
					fenlei: JSON.parse(this.$route.query.arr).DICTIONARIES_CLASSIFY, //分类
				},
				isTiJiao:false,
				xuhao: JSON.parse(this.$route.query.arr).ID,
				bianma: JSON.parse(this.$route.query.arr).DICTIONARIES_CODE,
				tableData: [],
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				loading: false, //搜索加载状态
				scoped: false,
				staffcopy: [{
						Code: 1,
						Name: "启用"
					},
					{
						Code: 0,
						Name: "禁用"
					}
				],
				staff: [{
						Code: 1,
						Name: "启用"
					},
					{
						Code: 0,
						Name: "禁用"
					}
				], //状态
				staffz: [{
						Code: 1,
						Name: "启用"
					},
					{
						Code: 0,
						Name: "禁用"
					}
				],
				fenleicopy: [{
						Code: 0,
						Name: "问题"
					},
					{
						Code: 1,
						Name: "产品线"
					},
					{
						Code: 2,
						Name: "角色"
					},
					{
						Code: 3,
						Name: "远程工具"
					},
					{
						Code: 5,
						Name: "工单问题原因"
					}
				],
				fenleiarr: [{
						Code: 0,
						Name: "问题"
					},
					{
						Code: 1,
						Name: "产品线"
					},
					{
						Code: 2,
						Name: "角色"
					},
					{
						Code: 3,
						Name: "远程工具"
					},
					{
						Code: 5,
						Name: "工单问题原因"
					}
				], //状态
				fenleiz: [{
						Code: 0,
						Name: "问题"
					},
					{
						Code: 1,
						Name: "产品线"
					},
					{
						Code: 2,
						Name: "角色"
					},
					{
						Code: 3,
						Name: "远程工具"
					},
					{
						Code: 5,
						Name: "工单问题原因"
					}
				],
				/*表单规则 */
				formRule: {
					feneli: [{
						required: true,
						message: "请选择",
						// trigger: "blur"
					}],
					zidianmingcheng: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					zhuangtai: [{
						required: true,
						message: "请选择",
					}],

				},
			};
		},

		mounted() {
			// this.$nextTick(() => {
			// 	this.$refs.zidianmingcheng.focus()
			// })
			this.form.zidianmingcheng = JSON.parse(this.$route.query.arr).TITLE;
			this.form.zhuangtai = JSON.parse(this.$route.query.arr).DICTIONARIES_STATUS;
			this.form.fenlei = JSON.parse(this.$route.query.arr).DICTIONARIES_CLASSIFY;
			this.xuhao = JSON.parse(this.$route.query.arr).ID;
			this.bianma = JSON.parse(this.$route.query.arr).DICTIONARIES_CODE;

		},
		activated() {
			this.form.zidianmingcheng = JSON.parse(this.$route.query.arr).TITLE;
			this.form.zhuangtai = JSON.parse(this.$route.query.arr).DICTIONARIES_STATUS;
			this.form.fenlei = JSON.parse(this.$route.query.arr).DICTIONARIES_CLASSIFY;
			this.xuhao = JSON.parse(this.$route.query.arr).ID;
			this.bianma = JSON.parse(this.$route.query.arr).DICTIONARIES_CODE;
		},
		methods: {
			fanhui() {
				this.$router.go(-1);
			},
			dianjifenlei() {
				this.fenleiarr = this.fenleiz;

			},
			bindSelectChange(val) {
				if (val) {
					this.fenleiarr = this.fenleicopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.fenleiarr = this.fenleicopy
				}

			},
			dianjizhuangtai() {
				this.staff = this.staffz;

			},
			bindSelectChangezt(val) {
				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},


			/**提交选项 */
			submitForm() {
				console.log()

				this.$refs.form.validate((valid) => {
					if (valid) {

						if (this.form.zidianmingcheng.length == 0 || this.form.zidianmingcheng.length > 0 &&
							this.form
							.zidianmingcheng.trim().length == 0) {
							this.$message({
								message: "权限名称不能为空！",
								type: "error",
							});
						} else if (this.form.fenlei.length == 0) {
							this.$message({
								message: "分类不能为空！",
								type: "error",
							});
						} else if (this.form.zhuangtai.length == 0) {
							this.$message({
								message: "状态不能为空！",
								type: "error",
							});
						} else {
							var zhongwenzhujima = "";
							pinyin.setOptions({
								checkPolyphone: false,
								charCase: 0
							});
							zhongwenzhujima = pinyin.getCamelChars(this.form.zidianmingcheng)
							console.log(zhongwenzhujima)
							let data = {

								ID: this.xuhao, //序号
								DICTIONARIES_CODE: this.bianma, //编码
								TITLE: this.form.zidianmingcheng, //中文名称
								MNEMONIC_CODE: zhongwenzhujima, //中文助记码
								DICTIONARIES_CLASSIFY: this.form.fenlei, //分类
								DICTIONARIES_STATUS: this.form.zhuangtai, //状态


							};


							this.isTiJiao = true;

							this.scoped = true;

							this.$request({
									method: "post",
									url: "Dictionary/Edit",
									data: data,
								})
								.then(() => {
									this.isTiJiao=false;
									this.$message({
										message: "发起成功！",
										type: "success",
									});
									this.$router.go(-1);

								})
								.catch((err) => {
									this.isTiJiao=false;
									if (err == "Error: Request failed with status code 401") {
										this.$router.push({
											path: "/login",
										});
									}
								});
						}

					}
					// }
				});
			},
			/**重置表单 */
			resetForm() {
				this.$refs.form.resetFields();
			},
			//回车事件
			xzlujingdizhi() {
				this.$nextTick(() => {
					this.$refs.lujingdizhi.focus()
				})
			},


			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun();
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun();
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun();
			},


		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #F0F0F0;
	}

	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.header {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headera {
		margin-bottom: 2px;
	}



	.fanhuiBtn {
		margin-top: 0px;
		margin-left: 50px;
		margin-bottom: 0px;
		display: inline-block;
	}

	.el-input {
		width: 100px;
	}

	.yonghuminglabe {
		margin-top: 30px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	.tijiaobtn {
		margin-left: 50%;
		margin-top: 10px;
		width: 100px;
		margin-bottom: 20px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 30px;
	}

	.header-cona {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	/**输入框宽度 */
	.form-item-input {
		width: 400px;
	}

	/**输入框后面的备注 */
	.form-item-tip {
		display: inline-block;
		margin-left: 10px;
		color: #606266;
		font-size: 14px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/* 主体容器 */
	.maina {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}
	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
